// extracted by mini-css-extract-plugin
export default {"container":"TalkQRScan_container__F8+sW","result":"TalkQRScan_result__JGkuY"};